module.exports = __webpack_public_path__ + "4f2b100746531294fa4a29ebae29bb82.svg";